import {
  GET_CIRCUIT_BREAKER_CONFIG,
  GET_FEED_CONFIG,
  GET_FEED_CONFIG_HISTORY,
  GET_FEED_CONFIG_UNIQUE_CREATOR,
  SET_CIRCUIT_BREAKER_CONFIG,
  SET_FEED_CONFIG,
  SET_FEED_CONFIG_HISTORY,
  SET_FEED_CONFIG_UNIQUE_CREATOR,
  SET_LOADING,
  UPDATE_CIRCUIT_BREAKER_CONFIG,
  UPDATE_FEED_CONFIG,
} from 'redux/constants/FeedConfig';

export const updateFeedConfig = (payload) => {
  return {
    type: UPDATE_FEED_CONFIG,
    payload,
  };
};

export const getFeedConfig = () => {
  return {
    type: GET_FEED_CONFIG,
  };
};

export const setFeedConfig = (payload) => {
  return {
    type: SET_FEED_CONFIG,
    payload,
  };
};

export const setLoading = (payload) => {
  return {
    type: SET_LOADING,
    payload,
  };
};

export const getFeedConfigUniqueCreator = (payload) => {
  return {
    type: GET_FEED_CONFIG_UNIQUE_CREATOR,
    payload,
  };
};

export const setFeedConfigUniqueCreator = (payload) => {
  return {
    type: SET_FEED_CONFIG_UNIQUE_CREATOR,
    payload,
  };
};

export const getFeedConfigHistory = (payload) => {
  return {
    type: GET_FEED_CONFIG_HISTORY,
    payload,
  };
};

export const setFeedConfigHistory = (payload) => {
  return {
    type: SET_FEED_CONFIG_HISTORY,
    payload,
  };
};

export const setCircuitBreakerConfig = (payload) => {
  return {
    type: SET_CIRCUIT_BREAKER_CONFIG,
    payload,
  };
};

export const getCircuitBreakerConfig = (payload) => {
  return {
    type: GET_CIRCUIT_BREAKER_CONFIG,
    payload,
  };
};

export const updateCircuitBreakerConfig = (payload) => {
  return {
    type: UPDATE_CIRCUIT_BREAKER_CONFIG,
    payload,
  };
};
